import { render, staticRenderFns } from "./CategoryUpdateDialogParentCategory.vue?vue&type=template&id=7599fa40&scoped=true"
import script from "./CategoryUpdateDialogParentCategory.vue?vue&type=script&lang=ts"
export * from "./CategoryUpdateDialogParentCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7599fa40",
  null
  
)

export default component.exports